import React from "react";
import { UserCheck, PhoneCall, Shield, Bell } from "lucide-react";

export default function SafetyPriority() {
  return (
    <section className="py-8 md:py-10 bg-[#f4f2fb]">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <span className="text-xs font-extrabold text-purple-600 uppercase tracking-widest" data-aos="fade-down">Safety You Can Trust</span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mt-2 mb-12" data-aos="fade-up">Your Safety is Our Priority</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Box 1 */}
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center space-y-3" data-aos="zoom-in" data-aos-delay="0">
            <div className="w-12 h-12 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center">
              <UserCheck className="w-6 h-6" />
            </div>
            <h4 className="font-bold text-slate-800 text-sm">Profile Verification</h4>
            <p className="text-xs text-slate-500">Every profile is verified for absolute authenticity.</p>
          </div>

          {/* Box 2 */}
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center space-y-3" data-aos="zoom-in" data-aos-delay="150">
            <div className="w-12 h-12 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center">
              <PhoneCall className="w-6 h-6" />
            </div>
            <h4 className="font-bold text-slate-800 text-sm">Trusted Contacts</h4>
            <p className="text-xs text-slate-500">Share your live trip details directly with family.</p>
          </div>

          {/* Box 3 */}
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center space-y-3" data-aos="zoom-in" data-aos-delay="300">
            <div className="w-12 h-12 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center">
              <Shield className="w-6 h-6" />
            </div>
            <h4 className="font-bold text-slate-800 text-sm">Safe Mode</h4>
            <p className="text-xs text-slate-500">Explore with full confidence using in-app Safe Mode.</p>
          </div>

          {/* Box 4 */}
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center space-y-3" data-aos="zoom-in" data-aos-delay="450">
            <div className="w-12 h-12 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center">
              <Bell className="w-6 h-6" />
            </div>
            <h4 className="font-bold text-slate-800 text-sm">SOS Emergency</h4>
            <p className="text-xs text-slate-500">Instant one-tap local SOS alerts in emergencies.</p>
          </div>


        </div>
      </div>
    </section>
  );
}
